import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Schema from "../components/Schema";

const BuyChemiTekPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const product = location.state?.product;

  const [formData, setFormData] = useState({
    name: "",
    quantity: "",
    email: "",
    address: "",
    phone: "",
  });

  if (!product) {
    return (
      <div className="p-8 text-center text-gray-500 text-lg font-medium">
        Product not found. Please go back and try again.
      </div>
    );
  }

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const msg = `Buying Request:
Name: ${formData.name}
Product: ${product.name}
Quantity: ${formData.quantity}
Email: ${formData.email}
Address: ${formData.address}
Phone: ${formData.phone}`;

    const encodedMsg = encodeURIComponent(msg);
    window.open(`https://wa.me/94777129021?text=${encodedMsg}`, "_blank");
    navigate(-1);
  };

  return (
    
    <div className="min-h-screen flex justify-center items-start px-6 py-16 bg-[#f9f9f9]">
    <Schema />
  <div className="w-full max-w-6xl flex flex-col md:flex-row gap-20 bg-white rounded-[40px] p-12 md:p-20">
    {/* Left Side - Product Details */}
    <div className="md:w-1/2">
      
      <h1 className="text-3xl font-bold text-black mb-6">{product.name}</h1>
      <p className="text-gray-500 text-base leading-relaxed mb-2">{product.desc}</p>

      <div className="mb-10">
        <img
          src={product.image}
          alt={product.name}
          className="w-full max-h-80 object-contain"
        />
      </div>

      {/* Brochures */}
      {product.brochures?.length > 0 && (
        <div className="mb-6">
          <h3 className="text-sm uppercase tracking-wider text-gray-800 font-semibold mb-2">
            Brochures
          </h3>
          <ul className="space-y-1">
            {product.brochures.map((item, i) => (
              <li key={i}>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Technical Sheets */}
      {product.technicalSheets?.length > 0 && (
        <div>
          <h3 className="text-sm uppercase tracking-wider text-gray-800 font-semibold mb-2">
            Technical Sheets
          </h3>
          <ul className="space-y-1">
            {product.technicalSheets.map((item, i) => (
              <li key={i}>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>

    {/* Right Side - Form */}
    <form
      onSubmit={handleSubmit}
      className="md:w-1/2 space-y-6 text-gray-800"
      noValidate
    >
      {[
        { label: 'Full Name', name: 'name', type: 'text' },
        { label: 'Email', name: 'email', type: 'email' },
        { label: 'Quantity', name: 'quantity', type: 'number' },
        { label: 'Address', name: 'address', type: 'text' },
        { label: 'Phone Number', name: 'phone', type: 'tel' },
      ].map(({ label, name, type }) => (
        <div key={name}>
          <label className="block text-sm mb-2 font-medium">{label}</label>
          <input
            name={name}
            type={type}
            required
            min={type === 'number' ? 1 : undefined}
            value={formData[name]}
            onChange={handleChange}
            placeholder={label}
            className="w-full px-4 py-3 text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
          />
        </div>
      ))}

      <div className="flex justify-between pt-6">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="text-gray-600 hover:text-black transition text-sm"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="bg-black text-white rounded-full px-6 py-3 text-sm font-medium hover:bg-gray-800 transition"
        >
          Continue
        </button>
      </div>
    </form>
  </div>
</div>

  );
};

export default BuyChemiTekPage;